import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    SimpleChange,
} from '@angular/core';
import { SelectedItem } from '@models/selectedItem';

@Component({
    selector: 'app-select-dropdown',
    templateUrl: './select-dropdown.component.html',
    styleUrls: ['./select-dropdown.component.scss'],
    standalone: false
})
export class SelectDropDownComponent {
    readonly CLICK_EVENT = 'click';

    @Input() items!: SelectedItem[];
    @Input() noneSelectName!: string;

    @Output() onSelectChange = new EventEmitter();

    public dropdownOpen = false;
    public selectedItemName = '';

    constructor(private eRef: ElementRef) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            if (this.dropdownOpen) {
                this.dropdownOpen = false;
            }
        }
    }

    ngOnChanges(changes: SimpleChange): void {
        this.createSelectedItemName();
    }

    onItemClick(e: MouseEvent, index: number) {
        this.items[index].selected = !this.items[index].selected;
        const selectedItems = this.items.filter((item) => item.selected);

        this.onSelectChange.emit(selectedItems);
        e.stopImmediatePropagation();
        this.createSelectedItemName();
    }

    createSelectedItemName() {
        const selectedItems = this.items.filter((item) => item.selected);
        if (!selectedItems.length) {
            this.selectedItemName = '';
            return;
        }
        const selectedItemsName = selectedItems[0].name;
        const selectedItemsNum = selectedItems.length - 1;
        this.selectedItemName =
            selectedItemsName + (selectedItemsNum ? ` (+${selectedItemsNum})` : '');
    }

    onDropdownClick(e: MouseEvent) {
        this.dropdownOpen = !this.dropdownOpen;
    }
}
